<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2" v-if="id > 0">Toets bewerken (coördinator)</span>
				<span class="pl-2" v-else>Nieuwe toets (coördinator)</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<v-form>
				<v-row>
					<v-col cols="12" sm="6">
						<v-select
							dense
							disabled
							:items="schoolyears"
							item-text="name"
							item-value="id"
							v-model="form.schoolyear_id"
							filled
							label="Schoolyear"
						></v-select>
						<v-select
							dense
							:items="studys"
							item-text="name"
							item-value="id"
							v-model="form.study_id"
							filled
							label="Opleiding"
						></v-select>
						<v-select
							dense
							:items="classs"
							item-text="name"
							item-value="id"
							v-model="form.class_id"
							filled
							label="Klas"
						></v-select>
						<v-select
							dense
							:items="periodes"
							item-text="name"
							item-value="id"
							v-model="form.periode_id"
							filled
							label="Periode"
						></v-select>
						<v-select
							dense
							:items="employees"
							item-text="tbl_employee.teacher_name"
							item-value="employee_id"
							v-model="form.employee_id"
							filled
							label="Docent"
						></v-select>
						<v-select
							dense
							:items="subjects"
							item-text="tbl_sys_subject.name"
							item-value="subject_id"
							v-model="form.subject_id"
							filled
							label="Deelkwalificatie"
						></v-select>
						<v-select
							dense
							:items="modules"
							item-text="module"
							item-value="id"
							v-model="form.teacher_subject_class_id"
							filled
							label="Module"
						></v-select>
						<v-select
							dense
							disabled
							:items="exam_types"
							item-text="name"
							item-value="id"
							v-model="form.exam_type_id"
							filled
							label="Toets type"
						></v-select>
					</v-col>
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-btn color="primary" @click="submitForm(id)" depressed>Save</v-btn>
			<v-btn color="dark" @click="$router.go(-1);" depressed>Cancel</v-btn>
		</v-card-actions>

		<v-snackbar v-model="snackbar" bottom color="red" right :timeout="10000" top>
			Schooljaar en Klas van het student zijn niet geselecteerd! Ga naar de het tab "Klas" om deze in te stellen!
			<v-btn dark text @click="snackbar = false">Close</v-btn>
		</v-snackbar>
	</v-card>
</template>

<script>
import Axios from "axios";
import { API_ROOT } from "../../config";

const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

const COORDINATOR_EXAM_TYPE_ID = 8;

export default {
	name: "examCoordinatorAddEdit",
	props: ["id"],
	data() {
		return {
			user: JSON.parse(localStorage.getItem("user") || "{}"),
			loading: false,
			snackbar: false,
			classs: [],
			studys: [],
			subjects: [],
			modules: [],
			periodes: [],
			employees: [],
			schoolyears: [],
			exam_types: [],
			users: [],
			form: {
				id: 0,
				schoolyear_id: null,
				sector_id: null,
				study_id: null,
				class_id: null,
				periode_id: null,
				employee_id: null,
				subject_id: null,
				teacher_subject_class_id: null,
				exam_type_id: null
			}
		};
	},
	created: function() {
		this.getUsers();
		this.getMyStudies();
		this.getPeriode();
		this.getSchoolyears();
		this.getExamTypes();
		if (this.id > 0) {
			this.getExam(this.id);
		}
	},
	watch: {
		studys: function(val) {
			this.applyStudyFromQuery(val);
		},
		"form.study_id": function(value) {
			this.syncSectorFromStudy(value);
			this.getClass(value);
		},
		"form.periode_id": function() {
			this.getEmployee();
		},
		"form.employee_id": function() {
			this.getSubject();
		},
		"form.subject_id": function() {
			this.getModule();
		}
	},
	methods: {
		applyCoordinatorExamTypeFromList: function() {
			var wanted = COORDINATOR_EXAM_TYPE_ID;
			if (!this.exam_types || !this.exam_types.length) {
				this.form.exam_type_id = wanted;
				return;
			}
			var found = this.exam_types.find(function(et) {
				return Number(et.id) === wanted;
			});
			if (found != null) {
				this.form.exam_type_id = found.id;
			} else {
				this.form.exam_type_id = wanted;
			}
		},
		applyCoordinatorDefaults: function() {
			this.applyCoordinatorExamTypeFromList();
			if (this.schoolyears && this.schoolyears.length) {
				this.form.schoolyear_id = this.schoolyears[0].id;
			}
		},
		applyStudyFromQuery(studys) {
			if (!studys || !studys.length || this.id > 0) return;
			const q = this.$route.query.study_id;
			if (q == null || q === "") return;
			const sid = parseInt(String(q), 10);
			if (Number.isNaN(sid)) return;
			this.form.study_id = sid;
			this.syncSectorFromStudy(sid);
			this.getClass();
		},
		syncSectorFromStudy(studyId) {
			if (!studyId) return;
			var s = this.studys.find(function(x) {
				return x.id === studyId;
			});
			if (!s) return;
			if (s.sector_id != null) {
				this.form.sector_id = s.sector_id;
			} else if (s.tbl_sys_sector && s.tbl_sys_sector.id != null) {
				this.form.sector_id = s.tbl_sys_sector.id;
			}
		},
		normalizeListPayload(payload) {
			if (payload == null) return [];
			if (Array.isArray(payload)) return payload;
			if (typeof payload === "object") {
				if (Array.isArray(payload.data)) return payload.data;
				if (Array.isArray(payload.records)) return payload.records;
				if (Array.isArray(payload.items)) return payload.items;
			}
			return [];
		},
		listRequestParams() {
			var u = this.user || {};
			var params = {};
			if (u.id != null) params.user_id = u.id;
			else if (u.user_id != null) params.user_id = u.user_id;
			return params;
		},
		getMyStudies: function() {
			var self = this;
			var params = self.listRequestParams();
			if (params.user_id == null) {
				return;
			}
			console.log("study/coordinator_study user_id:", params.user_id);
			ax.get("/study/coordinator_study", {
				params: params
			}).then(function(response) {
				self.studys = self.normalizeListPayload(response.data);
			});
		},
		getSchoolyears: function() {
			var self = this;
			ax.get("/schoolyear/all").then(function(response) {
				var list = self.normalizeListPayload(response.data);
				if (!list.length && Array.isArray(response.data)) {
					list = response.data;
				}
				self.schoolyears = list;
				self.applyCoordinatorDefaults();
			});
		},
		getSubject: function() {
			var self = this;
			ax.get("/teacher_subject_class/all_exam_teacher_subject/", {
				params: {
					class_id: self.form.class_id,
					periode_id: self.form.periode_id,
					employee_id: self.form.employee_id
				}
			}).then(function(response) {
				self.subjects = response.data;
			});
		},
		getModule: function() {
			var self = this;
			ax.get("/teacher_subject_class/all_exam_teacher_module/", {
				params: {
					class_id: self.form.class_id,
					periode_id: self.form.periode_id,
					employee_id: self.form.employee_id,
					subject_id: self.form.subject_id
				}
			}).then(function(response) {
				self.modules = response.data;
			});
		},
		getExam: function(id) {
			var self = this;
			this.loading = true;
			ax.get("/exam/single/" + id).then(function(response) {
				self.form = response.data;
				self.syncSectorFromStudy(self.form.study_id);
				self.applyCoordinatorDefaults();
				self.loading = false;
			});
		},
		getClass: function() {
			var self = this;
			if (!self.form.study_id) return;
			ax.get("/school_class/selected_study/", {
				params: {
					study_id: self.form.study_id
				}
			}).then(function(response) {
				self.classs = response.data;
			});
		},
		getPeriode: function() {
			var self = this;
			ax.get("/periode/all").then(function(response) {
				self.periodes = response.data;
			});
		},
		getUsers: function() {
			var self = this;
			ax.get("/users/all").then(function(response) {
				self.users = response.data;
			});
		},
		getExamTypes: function() {
			var self = this;
			ax.get("/exam_type/all").then(function(response) {
				var list = self.normalizeListPayload(response.data);
				if (!list.length && Array.isArray(response.data)) {
					list = response.data;
				}
				self.exam_types = list;
				self.applyCoordinatorExamTypeFromList();
			});
		},
		getEmployee: function() {
			var self = this;
			ax.get("/teacher_subject_class/all_exam_teacher/", {
				params: {
					class_id: self.form.class_id,
					periode_id: self.form.periode_id
				}
			}).then(function(response) {
				self.employees = response.data;
			});
		},
		submitForm() {
			var self = this;
			self.applyCoordinatorExamTypeFromList();
			self.applyCoordinatorDefaults();
			self.form.subject_module = self.subjects.name;
			if (this.form.id > 0) {
				ax.post("/exam/update/" + this.form.id, this.form).then(function() {
					self.$router.push({
						path: "/schooladmin/exam_coordinator"
					});
				});
			} else {
				ax.post("/exam/create", this.form).then(function() {
					self.$router.push({
						path: "/schooladmin/exam_coordinator"
					});
				});
			}
		}
	}
};
</script>

<style slot-scoped>
</style>
